import * as React from 'react';

function SvgRulers(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 57 65" {...props}>
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.4 52.26h29.413v11.66H1"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.4 52.26V1H1v62.92zM1 48.703h2.887M1 40.272h2.887M1 31.84h2.887M1 23.406h2.887M1 14.974h2.887M1 6.542h2.887M14.398 60.033v3.887M23.305 60.033v3.887M32.214 60.033v3.887M25.208 13.414l-1.525 1.523M31.394 19.6l-1.525 1.523M37.58 25.786l-1.526 1.523M43.766 31.972l-1.526 1.523M49.952 38.158l-1.526 1.522M19.473 7.624 56 44.151H19.473z"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M25.543 22.279 41.346 38.08H25.543z"
    />
  </svg>)
}
export default SvgRulers;
